import { render, staticRenderFns } from "./NotificationReminderActivity.vue?vue&type=template&id=20b75842&scoped=true&"
import script from "./NotificationReminderActivity.vue?vue&type=script&lang=js&"
export * from "./NotificationReminderActivity.vue?vue&type=script&lang=js&"
import style0 from "./NotificationReminderActivity.vue?vue&type=style&index=0&id=20b75842&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b75842",
  null
  
)

export default component.exports